import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-circle",
  "use": "arrow-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-circle\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#6644EA\" fill-rule=\"nonzero\" /><path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-width=\"2\" d=\"m13 17 5-5-5-5\" /><circle cx=\"8\" cy=\"12\" r=\"2\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol